<template>
  <div>
    <h3>
      <b>{{ $t('FAQ.extend') }}</b>
    </h3>
    <hr />
    <h3>
      <b>5.1 Cara Perpanjang melalui Aplikasi Mobile (Android)</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih “Perpanjang Membership” di bagian atas halaman beranda pada tampilan aplikasi mobile
        anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_13.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Atau, pilih “Beli Paket” di toolbar bagian bawah aplikasi mobile anda, berada di posisi
        kedua sisi kiri bawah aplikasi
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_14.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>Pilih “Perpanjang Membership”</li>
      <br />
      <li>
        Pilih tipe membership yang anda inginkan dengan menekan kotak paket membership
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_15.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih waktu aktivasi membership perpanjangan anda dari 2 pilihan:
        <ol>
          <li>
            Aktifkan Sekarang. Perpanjangan anda akan mulai lebih awal, sehingga paket lama dan koin
            bawaan paket lama anda akan dihapus. Paket baru akan terhitung 1 tahun mulai dari hari
            perpanjangan.
          </li>
          <li>
            Aktifkan Nanti. Perpanjangan anda akan mulai setelah paket lama anda berakhir. sehingga
            masa aktif paket baru akan dimulai 1 tahun setelah paket lama selesai.
          </li>
        </ol>
        <div class="wrapper--img">
          <div class="d-flex justify-center align-center">
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_16.png"
              alt=""
              style="max-height: 200px; margin: 0 24px"
            />
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/mobile/mobile_17.png"
              alt=""
              style="max-height: 200px; margin: 0 24px"
            />
          </div>
        </div>
      </li>
      <br />
      <li>Geser ke bawah dan tekan tombol “Lanjut ke Checkout”</li>
      <br />
      <li>Lanjut ke bagian Cara Pembayaran</li>
    </ul>
    <hr />
    <h3>
      <b>5.2 Cara Perpanjang melalui Browser Laptop/PC</b>
    </h3>
    <br />
    <ul>
      <li>
        Pilih “Perpanjang Membership” di bagian atas halaman beranda pada tampilan browser laptop/PC
        anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/extend-6.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Atau, pilih “Beli Paket” di toolbar toolbar bagian kiri atas tampilan browser anda
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/desktop/desktop_16_2.jpg"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih tipe membership yang anda inginkan dengan menekan kotak paket membership
        <div class="wrapper--img">
          <img
            src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/extend-7.png"
            alt=""
          />
        </div>
      </li>
      <br />
      <li>
        Pilih waktu aktivasi membership perpanjangan anda dari 2 pilihan:
        <ol>
          <li>
            Aktifkan Sekarang. Perpanjangan anda akan mulai lebih awal, sehingga paket lama dan koin
            bawaan paket lama anda akan dihapus. Paket baru akan terhitung 1 tahun mulai dari hari
            perpanjangan.
          </li>
          <li>
            Aktifkan Nanti. Perpanjangan anda akan mulai setelah paket lama anda berakhir. sehingga
            masa aktif paket baru akan dimulai 1 tahun setelah paket lama selesai.
          </li>
        </ol>
        <div class="wrapper--img">
          <div class="d-flex justify-center align-center">
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/extend-8.png"
              alt=""
              style="max-height: 200px; margin: 0 24px"
            />
            <img
              src="https://beliruma.s3.ap-southeast-1.amazonaws.com/public/static/img/faq/extend-9.png"
              alt=""
              style="max-height: 200px; margin: 0 24px"
            />
          </div>
        </div>
      </li>
      <br />
      <li>Tekan tombol “Lanjut ke Checkout”</li>
      <br />
      <li>Lanjut ke bagian Cara Pembayaran</li>
    </ul>
    <hr />
  </div>
</template>

<script>
export default {
  name: 'AccountPurchase',
};
</script>

<style></style>
